import { render, staticRenderFns } from "./RecipeSummary.vue?vue&type=template&id=c13204f8&scoped=true"
import script from "./RecipeSummary.vue?vue&type=script&lang=js"
export * from "./RecipeSummary.vue?vue&type=script&lang=js"
import style0 from "./RecipeSummary.vue?vue&type=style&index=0&id=c13204f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13204f8",
  null
  
)

export default component.exports